// extracted by mini-css-extract-plugin
module.exports = {"mainNavigation":"navigation-main-module--main-navigation--3P6kN"};